import { head, path, pathOr, pipe, propOr } from 'ramda'

export const getQueryName = pipe(
  propOr([], 'definitions'), //
  head,
  pathOr([], ['selectionSet', 'selections']), //
  head,
  path(['name', 'value'])
)

export const getMutationName = getQueryName
